import { createAction } from '@reduxjs/toolkit';

export const setLogsFilter = createAction('setLogsFilter');
export const resetLogsFilter = createAction('resetLogsFilter');
